import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layouts/Layout.vue' 
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import PasswordReset from '../views/PasswordReset.vue'
import store from '@/store';
import ASSETS_ROUTES from './assets.routes'
import CLIENTS_ROUTES from './clients.routes'
import USER_ROLES_ROUTES from './user_roles.routes'
import USERS_ROUTES from './users.routes'
import CATEGORIES_ROUTES from './categories.routes';
import SUBCATEGORIES_ROUTES from './subcategories.routes';
import registrationArea from './registrationArea.routes';
import FEES from './fees.routes';
import movimentActivesList from './movimentActivesList.routes';
import positionActivesList from './positionActivesList.routes';

Vue.use(VueRouter)

const isLoggedIn = (to, from, next) => {
  if (store.getters.isLoggedIn === true) {
    next();
    return;
  }

  next('/login');
};

const isNotLoggedIn = (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    next();
    return;
  }

  next('/');
};

const routes = [
  {
    path: '/',
    name: 'Página Inicial',
    component: Layout,
    beforeEnter: isLoggedIn,
    children: [
      {
        path: '',
        name: 'index',
        component: Home,
      },
      ASSETS_ROUTES,
      CLIENTS_ROUTES,
      USER_ROLES_ROUTES,
      USERS_ROUTES,
      CATEGORIES_ROUTES,
      SUBCATEGORIES_ROUTES,
      registrationArea,
      FEES,
      movimentActivesList,
      positionActivesList
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: isNotLoggedIn,
  },
  {
    path: '/reset-password',
    name: 'reset_password',
    component: PasswordReset,
    beforeEnter: isNotLoggedIn,
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
